import moment from "moment";
import React from "react";
import { TCRBRecord } from "../../../../../redux/app/crb/@types";
import { TCRBE1 } from "../../../../../redux/app/crb/groups/crb-e";
import { commonUtils } from "../../../../../redux/_common";
import CRBTableRows from "../CRBTableRows";

type OwnProps = {
	crbRecord: TCRBRecord;
	isStrikedOff?: boolean;
};
type CRBE1PreviewProps = OwnProps;
function CRBE1Preview(props: CRBE1PreviewProps) {
	const crbRecord = props.crbRecord as TCRBE1;
	const operationDate = moment(crbRecord.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);

	function renderMain() {
		return (
			<CRBTableRows
				record={crbRecord}
				tableRows={[
					[operationDate, "E", "_", renderItem15P2()],
					[null, null, 15, renderItem15()],
					[null, null, "15.1,15.2,15.3", renderItem15P1()],
					[null, null, 16, renderItem16()],
					[null, null, "NOTE", crbRecord.remarks],
				]}
			/>
		);
	}

	function renderItem15() {
		if (crbRecord.item15.tanks.length > 0) {
			const totalQuantityDischarged = crbRecord.item15.tanks.reduce<number>(
				(result, tank) => commonUtils.addUp(tank.transferQuantity, result),
				0
			);
			return (
				<>
					<table className="min-w-full table-auto border-collapse">
						<thead className="bg-gray-600">
							<tr>
								<th className="px-4 py-2 border text-center">Tank</th>
								<th className="px-4 py-2 border text-center">
									Discharge Quantity
								</th>
								<th className="px-4 py-2 border text-center">Category</th>
								<th className="px-4 py-2 border text-center">Substance</th>
							</tr>
						</thead>
						<tbody>
							{crbRecord.item15.tanks.map((tank) => {
								return (
									<tr key={tank.selectedTank.id}>
										<td className="px-4 py-2 border text-center">
											{tank.selectedTank.tankCode}
										</td>
										<td className="px-4 py-2 border text-center">
											{tank.transferQuantity}
										</td>
										<td className="px-4 py-2 border text-center">
											{tank.catgeory}
										</td>
										<td className="px-4 py-2 border text-center">
											{tank.substance}
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>

					<br />
					<h4 className="font-medium uppercase">
						Total Quantity Discharged: {totalQuantityDischarged.toFixed(2)} M³
					</h4>
				</>
			);
		}
		return <>----</>;
	}

	function renderItem15P1() {
		const { procedure, cleaningAgents, ventilationProcedure } =
			crbRecord.item15P1;

		return (
			<h4 className="font-medium uppercase">
				<ul>
					<li>{procedure}</li>
					<li>{cleaningAgents}</li>
					<li>{ventilationProcedure}</li>
				</ul>
			</h4>
		);
	}
	function renderItem15P2() {
		const { startDate, startTime, endDate, endTime } = crbRecord.item15P2;

		const startDateTimeLocal = `${startDate}T${startTime}:00${crbRecord.timeZone}`;
		const startUtcTime = moment.utc(startDateTimeLocal);

		const endDateTimeLocal = `${endDate}T${endTime}:00${crbRecord.timeZone}`;
		const endUtcTime = moment.utc(endDateTimeLocal);

		return (
			<>
				<h4 className="font-medium uppercase">
					Commenced At: {startUtcTime.format("HH:mm")} hrs (UTC) ({startTime}{" "}
					SMT)
				</h4>

				<h4 className="font-medium uppercase">
					Stopped At: {endUtcTime.format("HH:mm")} hrs (UTC) ({endTime} SMT)
				</h4>
			</>
		);
	}

	function getTransfers() {
		const { transfer } = crbRecord.item16;
		const { place } = transfer;
		if (place === "AT_SEA") {
			return (
				<>
					<>Into the Sea</>
					<br />
					<>
						Commenced Position: {transfer.startPosition.latitude} /{" "}
						{transfer.startPosition.longitude}
					</>
					<br />
					<>
						Stopped Position: {transfer.endPosition.latitude}/
						{transfer.endPosition.longitude}
					</>
				</>
			);
		} else if (place === "AT_RECEPTION_FACILITY") {
			let {
				receiptNumber,
				receptionFacilityName,
				portName,
				receiptAttachment,
			} = transfer;
			return (
				<ul>
					<li>Reception Facility : {receptionFacilityName}</li>
					<li>Port: {portName}</li>
					<li>Receipt: {receiptNumber}</li>
					<li>Attachment: {receiptAttachment}</li>
				</ul>
			);
		} else if (place === "TO_TANK") {
			const { tanks } = transfer;
			if (tanks.length > 0) {
				return (
					<table className="min-w-full table-auto border-collapse">
						<thead className="bg-gray-600">
							<tr>
								<th className="px-4 py-2 border text-center">Tank</th>
								<th className="px-4 py-2 border text-center">
									Discharge Quantity
								</th>
								<th className="px-4 py-2 border text-center">Category</th>
								<th className="px-4 py-2 border text-center">Substance</th>
							</tr>
						</thead>
						<tbody>
							{tanks.map((tank) => {
								return (
									<tr key={tank.selectedTank.id}>
										<td className="px-4 py-2 border text-center">
											{tank.selectedTank.tankCode}
										</td>
										<td className="px-4 py-2 border text-center">
											{tank.transferQuantity}
										</td>
										<td className="px-4 py-2 border text-center">
											{tank.catgeory}
										</td>
										<td className="px-4 py-2 border text-center">
											{tank.substance}
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>
				);
			}
			return <>----</>;
		}
	}

	function renderItem16() {
		const { totalTransferQuantity } = crbRecord.item15P3;
		return (
			<h4 className="font-medium uppercase">
				Tanks Washings Transferred To:
				<br />
				{getTransfers()}
				<br />
				Total Quantity Transferred: {totalTransferQuantity.toFixed(2)} M³
			</h4>
		);
	}

	return renderMain();
}

export default CRBE1Preview;
